import { useCallback, useState } from 'react';
import { FCX, SelectComponent } from '@datassential/platform-ui-lib';
import cn from 'classnames';
import { ConsumerRatingsPreset } from '@apiHooks/useHomeConsumerRatings';
import './ConsumerRatingsVsBar.scss';

interface ConsumerRatingsVsBarProps {
    chainName: string;
    presets: ConsumerRatingsPreset[];
    selectedPreset: ConsumerRatingsPreset;
    onPresetSelect: (preset: ConsumerRatingsPreset) => void;
}

const ConsumerRatingsVsBar: FCX<ConsumerRatingsVsBarProps> = ({
    chainName,
    presets,
    selectedPreset,
    onPresetSelect,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleSelect = useCallback((preset: ConsumerRatingsPreset) => {
        onPresetSelect(preset);
        setIsOpen(false);
    }, [onPresetSelect]);

    return (
        <div className="ConsumerRatingsVsBar">
            <span className="ConsumerRatingsVsBar__chain-name">{chainName}</span>
            <span className="ConsumerRatingsVsBar__label">vs</span>
            <div className="ConsumerRatingsVsBar__select">
                <SelectComponent
                    isOpened={isOpen}
                    setIsOpened={setIsOpen}
                    thumbnailText={selectedPreset.name ?? ''}
                    dropdownProps={{
                        isOpened: isOpen,
                        place: 'bottom-start',
                        className: 'no-scroll-override',
                        style: {
                            display: 'block',
                            padding: 6,
                            minWidth: 200,
                            maxHeight: 300,
                            overflowY: 'auto',
                        },
                    }}
                >
                    <div>
                        {presets.map((preset) => (
                            <div
                                key={preset.id}
                                className={cn(
                                    'ConsumerRatingsVsBar__segment-item',
                                    selectedPreset.id === preset.id && 'is-selected',
                                )}
                                onClick={() => handleSelect(preset)}
                            >
                                {preset.name}
                            </div>
                        ))}
                    </div>
                </SelectComponent>
            </div>
        </div>
    );
};

export default ConsumerRatingsVsBar;
